import {useApi} from "./useApi";
import {useCallback, useEffect} from "react";
import {useNotify} from "./system/useNotify";
import {dispatcher} from "../store";
import {useStoreSelector} from "./redux/useStoreSelector";

export function useAccounts() {
  const accounts = useStoreSelector( s => s.accounts.list)
  const {api, isAuth} = useApi(),
    {addNotify, handleApiError} = useNotify()

  const loadAccounts = useCallback(() => {
    if (isAuth) {
      api.getAccounts({})
        .then(handleApiError)
        .then(dispatcher.accounts.setList)
        .catch(e => addNotify('error', 'Error', e.message))
    }
  }, [addNotify, api, handleApiError, isAuth])

  useEffect(() => {
    if (!accounts) {
      loadAccounts()
    }
  }, [accounts, loadAccounts])

  return {accounts, loadAccounts}
}
